import { createFileRoute, redirect } from '@tanstack/react-router';
import { EntityDetailLayout } from '@/app/(client)/my-styles/-components/EntityDetailLayout';
import {
  isEntityKindPath,
  skuDetailQueryOptions,
  styleDetailQueryOptions,
  variantDetailQueryOptions,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)/$kind/$id',
)({
  beforeLoad: ({ params, location }) => {
    if (!isEntityKindPath(params.kind)) {
      throw redirect({ to: '/my-components/components/active' });
    }
    const bare = `/my-components/${params.kind}/${params.id}`;
    if (location.pathname === bare || location.pathname === `${bare}/`) {
      throw redirect({
        to: '/my-components/$kind/$id/overview',
        params: { kind: params.kind, id: params.id },
      });
    }
  },
  loader: ({ params }) => {
    if (!isEntityKindPath(params.kind)) return;
    if (params.kind === 'styles') {
      return queryClient.ensureQueryData(styleDetailQueryOptions(params.id));
    }
    if (params.kind === 'variants') {
      return queryClient.ensureQueryData(variantDetailQueryOptions(params.id));
    }
    return queryClient.ensureQueryData(skuDetailQueryOptions(params.id));
  },
  component: EntityDetailRoute,
});

function EntityDetailRoute() {
  const { kind, id } = Route.useParams();
  if (!isEntityKindPath(kind)) return null;
  return <EntityDetailLayout kind={kind} id={id} />;
}
